<template>
    <div>
        <modal :show.sync="addItem" headerClasses="justify-content-center">
            <h6 slot="header" class="title title-up">Agregar detalle</h6>
                <div class="form-group">
                    <label>Detalle *</label>
                    <fg-input   type="text"
                                name="detalle"
                                placeholder="detalle"
                                autocomplete="off"
                                v-validate="modelValidations.item_name"
                                :error="getError('detalle')"
                                v-model="itemName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de compra</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="precio de compra" v-validate="modelValidations.sales" :error="getError('precio de compra')" separator="." class="form-control" v-model="itemPurchasePrice"></vue-numeric>
                </div>
                
            <template slot="footer">
                <div class="left-side">
                <p-button type="default" link @click="cancelAddItem()">Cancelar</p-button>
                </div>
                <div class="divider"></div>
                <div class="right-side">
                <p-button type="default" link @click="addItemToList()">Agregar</p-button>
                </div>
            </template>
        </modal>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title">Agregar ítem</h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Nombre *</label>
                    <fg-input   type="text"
                                name="nombre"
                                placeholder="nombre"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('nombre')"
                                v-model="productName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Promedio producción *</label>
                    <fg-input   type="number"
                                name="promedio mes"
                                placeholder="promedio mes"
                                autocomplete="off"
                                v-validate="modelValidations.product_name"
                                :error="getError('promedio mes')"
                                v-model="productSaleMonthly">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Precio de venta *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="precio de venta" v-validate="modelValidations.sales" :error="getError('precio de venta')" separator="." class="form-control" v-model="productSaleValue"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Tipo de costeo de insumos *</label>
                    <fg-input   tabindex="3"
                                name="tipo de costeo"
                                v-validate="modelValidations.product_name"
                                :error="getError('tipo de costeo')"
                                v-model="productSelect">
                            <el-select 
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="productSelect">
                            <el-option class="select-warning"
                                    value="unit"
                                    label="Individual">
                            </el-option>
                            <el-option class="select-warning"
                                    value="total"
                                    label="Total">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div v-if="productTotalSaleComputed != 0" class="alert alert-warning mt-2">
                    <span>Total: {{ setFormat(productTotalSaleComputed)}}</span>
                </div>
            </div>
            <div class="card-footer">
            </div>
        </card>
        <div class="text-right">
            <p-button v-if="productTotalSaleComputed != 0" @click="saveCosts()" type="warning">Siguiente</p-button>
            <p-button @click="toGeneralCosts()" type="default" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { Card, Collapse, CollapseItem, Modal } from 'src/components/UIComponents'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import {Select, Option} from 'element-ui'
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            PSwitch,
            VueNumeric,
            Collapse,
            CollapseItem,
            Modal
        },
        data() {
        return {
            form: {
                average_selection: '',
            },
            itemName: '',
            itemPurchasePrice: '',
            productName: '',
            productSaleValue: '',
            productSaleMonthly: '',
            productTotalSale: '',
            productCostPercent: 0,
            productSelect: 'unit',
            productMultiplier: 1,
            addItem: false,
            items: [
                
            ],
            modelValidations: {
                sales: {
                    required: true
                },
                item_name: {
                    required: false
                },
                product_name: {
                    required: false
                },
                average_selection: {
                    required: true
                }
            },
        }
        },
        watch: {
            productLinePurchaseCost: function (val) {
                if (val != 0) {
                    if (this.productLineMonthly != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLineMonthly);
                        this.productLineTotalFormat = this.setFormat(this.productLineTotal);
                        this.productLinePurchaseCostFormat = this.setFormat(val);
                    }
                }
                else {
                    this.productLineTotal = 0;
                    this.productLineTotalFormat = 0;
                    this.productLinePurchaseCostFormat = 0;

                }
            },
            productLineMonthly: function (val) {
                if (val != 0) {
                    if (this.productLinePurchaseCost != 0) {
                        this.productLineTotal = parseFloat(val) * parseFloat(this.productLinePurchaseCost)
                    }
                }
                else {
                    this.productLineTotal = 0;
                }
            }
            
        },
        computed: {
            productTotalSaleComputed () {
                var total = this.productSaleMonthly * this.productSaleValue;
                this.productTotalSale = total;
                return total;

            },
            costsMonthlyLine () {
                return 5000;
            },
            salesMonthlyAverage () {
                var avg = 0;
                var sum = 0;
                for (var i=0;i<this.items.length;i++) {
                    sum = sum + this.items[i].itemPercent;
                }
                avg = sum / this.items.length;
                return Math.round(avg);
            },
            validateGeneralCosts () {
                if(this.productLineName && this.productLinePurchaseCost != 0 && this.productLineMonthly && (this.items.length >= 3 && this.items.length <= 5)) {
                    return true
                }
                else {
                    return false
                }
            },
            
        },
        methods: {
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            addItemToList () {
                if (this.itemName == '' || this.itemPercent == 0) {
                    this.showNotificationError('El campo nombre de ítem y porcentaje no pueden estar vacíos');
                }
                else {
                    this.items.push({
                        itemName: this.itemName,
                        itemPurchasePrice: this.itemPurchasePrice,
                        itemSalePrice: this.itemSalePrice,
                        itemPercent: this.itemPercent
                    })
                    this.resetItem();
                    this.addItem = false;
                    this.showNotificationSuccess('Producto agregado correctamente');
                }
            },
            removeItem () {
                this.items.splice(this.items.length-1,1);
            },
            resetItem () {
                this.itemName= '',
                this.itemPurchasePrice= '',
                this.itemSalePrice= '',
                this.itemPercent= ''
            },
            addItemMethod () {
                this.addItem = true;
            },
            cancelAddItem () {
                this.addItem = false;
                this.resetItem();
            },
            dailySelectValidation () {
                if (this.checkboxes.filter(day => day.value == true).length) {
                    return false
                }
                else {
                    return true
                }
            },
            setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            /*** 
             * Función que permite visualizar los errores en cada campo del input
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            validateSwitch () {
                if(this.switches.daily || this.switches.weekly || this.switches.monthly || this.switches.product || this.switches.average) {
                    return true
                }
                else {
                    return false
                }
            },
            toGeneralCosts () {
                this.$router.push('/asessments/new_asessment/customer/costs/production/item');
            },
            saveCosts () {
                this.$store.dispatch('setCostsProductionItem', this.$data).then(()=>{
                    this.$router.push('/asessments/new_asessment/customer/costs/production/item');
                });
            }
        },
        mounted () {
        }
    }
</script>
<style>
</style>
